export const SET_LOADING = "setLoading";

export default {
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};
